module.exports = __webpack_public_path__ + "img/13.578673c4.png";